import { Injectable, EventEmitter } from '@angular/core';
import { Cart } from '../cart/cart';
import { Gift } from '../gift/gift';
import { CartItem } from '../cart/cartItem';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
@Injectable()

export class CartService {
  private cart: Cart;
  private cartKey = "hitchdCart";
  cartChanged: EventEmitter<Cart> = new EventEmitter<Cart>();
  constructor(

  ) {

  }

  private emitChangeSource = new Subject<Cart>();
  changeEmitted$ = this.emitChangeSource.asObservable();
  emitCartUpdated(updatedCart: Cart) {

    this.emitChangeSource.next(updatedCart);
  }
  public clearCart() {
    this.cart = new Cart();
    this.storeCartToLocalStorage();
    
  }
  public checkCart(gifts: Gift[]) {
    if (gifts && gifts.length && this.cart && this.cart.cartItems && this.cart.cartItems.length > 0) {
      this.cart.cartItems.forEach(cartItem => {
        if (gifts.filter(x => x.id === cartItem.gift.id).length === 0) {
          this.RemoveCartItem(cartItem);
        }


      });
    } else {
      this.clearCart();
    }
  }

  public giftTotal(): number {
    if (!this.cart) {
      this.cart = this.getCart();
    }
    if (!this.cart) {
      return 0;
    }
    return this.cart.cartItems.reduce((x, cv) => x + cv.price, 0);

  }

  public RemoveCartItem(cartItem: CartItem) {

    this.cart.cartItems = this.cart.cartItems.filter(x => x.gift.id != cartItem.gift.id)

    this.storeCartToLocalStorage();
  }

  public replaceCart(cart: Cart) {
    this.cart = cart;
    this.storeCartToLocalStorage();
  }

  public addToCart(gift: Gift, price: number) {
    this.loadCart();

    if (this.cart == null) {
      this.cart = new Cart();
      this.cart.cartItems = new Array<CartItem>();
    }

    var cartItemResult = this.cart.cartItems.filter(x => x.gift.id === gift.id);

    if (cartItemResult != null && cartItemResult.length > 0) {
      cartItemResult[0].price = price;
      //      this.cart.cartItems.push(cartItemResult[0]);
      this.storeCartToLocalStorage();
    }
    else {

      var cartItem = new CartItem();
      cartItem.gift = gift;
      cartItem.price = price;
      cartItem.isEditing = false;
      this.cart.cartItems.push(cartItem);
    }



    this.storeCartToLocalStorage();


  }

  private storeCartToLocalStorage() {
    var cartString = JSON.stringify(this.cart);
    localStorage.setItem('cart', cartString);
    this.emitCartUpdated(this.cart);
  }


  public getCart(): Cart {
    this.loadCart();
    if (this.cart != null) {
      return this.cart;
    }
    return new Cart();
  }


  private loadCart() {


    const cartString = localStorage.getItem('cart');
    if (cartString) {

      try {
        this.cart = JSON.parse(cartString);
      }
      catch (e) {
        this.cart = null;
      }
      return this.cart;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/cart/cart.service.ts